import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import React from 'react';
import SpecialistInfoCard from '../Components/SpecialistInfoCard';
import ConsultationDetailsForm from '../Components/ConsultationDetailsForm/ConsultationDetailsForm';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';
import PaymentSummaryCard from '../Components/ConsultationDetailsForm/PaymentSummaryCard';

export default function ServiceInfoStep({ goNext, goPrev }) {
  const [hasContraError, setHasContraError] = React.useState(false);

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:gap-4">
        <div className="sm:w-2/3">
          <Card>
            <CardHeader>
              <button
                type="button"
                onClick={goPrev}
                className="flex items-center gap-1 hover:opacity-80 focus:outline-none"
              >
                <ChevronLeft className="w-8 h-8 text-secondary" />
                <Heading variant="2">Paslaugos informacija</Heading>
              </button>
            </CardHeader>
            <CardContent>
              <ConsultationDetailsForm
                onValid={goNext}
                onContraErrorChange={setHasContraError}
              />
            </CardContent>
            <CardFooter>
              <Button
                type="submit"
                form="consultation-details-form-id"
                className="hidden sm:block sm:w-full"
                disabled={hasContraError}
                aria-disabled={hasContraError}
                title={
                  hasContraError
                    ? 'Pataisykite kontraindikacijų klaidą'
                    : undefined
                }
              >
                Pereiti prie apmokėjimo
              </Button>
            </CardFooter>
          </Card>
        </div>

        <div className="sm:w-1/3 mt-2 sm:mt-0">
          <div className="flex flex-col gap-4">
            <SpecialistInfoCard />
            <PaymentSummaryCard />
          </div>
        </div>
      </div>

      <div className="mt-6 sm:hidden">
        <Button
          type="submit"
          form="consultation-details-form-id"
          disabled={hasContraError}
          aria-disabled={hasContraError}
          title={
            hasContraError ? 'Pataisykite kontraindikacijų klaidą' : undefined
          }
        >
          Pereiti prie apmokėjimo
        </Button>
      </div>
    </div>
  );
}
